import React from "react";
import { Table } from "./Table";

const DEFAULT_FIXED_COLUMN_SIZE = 200;

const default_table_options = {
  headerOptions: {
    fixed: true,
  },
};

export const TableRenderer = ({
  classNames,
  data,
  columns,
  options,
  noDataRenderer,
  rowRendenderer,
}) => {
  const myOptions = { ...default_table_options, ...options };
  const columnsToRender = columns.sort((a, b) =>
    a.fixed === b.fixed ? 0 : a.fixed ? -1 : 1
  );

  let offset = 0;
  const columnStyleRequests = columnsToRender.map((x) => {
    const widthRequest =
      x.fixed ? x.widthRequest?.value ?? DEFAULT_FIXED_COLUMN_SIZE : x.widthRequest?.value;
    const offsetRequest = offset;
    offset += widthRequest ?? 0;
    return {
      width: widthRequest,
      minWidth: x.fixed ? widthRequest : x.widthRequest?.min,
      maxWidth: x.fixed ? widthRequest : x.widthRequest?.max,
      "--offset-request": `${offsetRequest}px`,
    };
  });

  return (
    <Table
      options={{ heightRequest: myOptions.heightRequest }}
      classNames={classNames}
    >
      <div className="overflow-x-auto">
        <table className="w-full  rounded overflow-hidden ">
          <thead className="bg-primary-table_header_bg border">
            <tr>
              {columnsToRender.map((x, i) => (
                <th
                  key={x.name}
                  style={columnStyleRequests[i]}
                  className="py-3 px-4  text-left text-base font-medium"
                >
                  {x.headerRenderer ? x.headerRenderer(x) : x.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="border">
            {data && data.length > 0 ? (
              data.map((x, i) => (
                rowRendenderer
                  ? <React.Fragment key={i}>{rowRendenderer(x, i, columnsToRender)}</React.Fragment>
                  : <tr key={i} className="border-t">
                    {columnsToRender.map((y, j) => (
                      <td
                        key={`${i}-${y.name}`}
                        style={columnStyleRequests[j]}
                        className={[y.fixed ? 'py-4 font-normal text-left text-sm' : 'py-4 text-left text-sm', y.fixed ? 'px-4' : 'px-4', ...(y.classNames ?? [])].join(' ')}>
                        {y.bodyRenderer(x, y)}
                      </td>
                    ))}
                  </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columnsToRender.length}
                  className="py-4 text-center text-gray-500 border-b"
                >
                  {noDataRenderer ? noDataRenderer() : "No data available"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Table>
  );
};
